module.exports = __webpack_public_path__ + "img/novo-nordisk-BW.9eaa179d.png";